import request from '@/utils/request';

function apiSelfUpdate(user) {
  const dto = {
    userID: user.id,
    ...user
  };
  delete dto.id;

  return request({
    data: dto,
    method: 'put',
    url: '/userprofile'
  });
}

function apiFetchStoreUser(id) {
  return request({
    method: 'get',
    url: '/user/' + id.toString()
  });
}

export const storeExtensions = {
  actions: {
    updateSelf({ dispatch }, user) {
      return apiSelfUpdate(user);
    },
    fetchStoreUser({ dispatch }, id) {
      return apiFetchStoreUser(id);
    }
  }
};
